export enum ZoneSkipArrivalScanModal {
  GAYLORD_NOT_FOUND = "ZONE_SKIP_ARRIVAL_GAYLORD_NOT_FOUND",
  GAYLORD_NOT_ELIGIBLE = "ZONE_SKIP_ARRIVAL_GAYLORD_NOT_ELIGIBLE",
  GAYLORD_NOT_ELIGIBLE_FOR_ARRIVAL_SCAN = "ZONE_SKIP_ARRIVAL_GAYLORD_NOT_ELIGIBLE_FOR_ARRIVAL_SCAN",
  UNKNOWN_ERROR = "ZONE_SKIP_ARRIVAL_UNKNOWN_ERROR",
}
